import { render, staticRenderFns } from "./UpImage.vue?vue&type=template&id=69cedca4&scoped=true&"
import script from "./UpImage.vue?vue&type=script&lang=js&"
export * from "./UpImage.vue?vue&type=script&lang=js&"
import style0 from "./UpImage.vue?vue&type=style&index=0&id=69cedca4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cedca4",
  null
  
)

export default component.exports